// extracted by mini-css-extract-plugin
export default {"pricingHeader":"v2jz1","pricingHeaderItem":"qAKae","removeTariff":"DM0r0","fieldClassName":"AzFOB"};